import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const doughnutLabel = {
  id: "doughnutLabel",
  afterDatasetsDraw(chart, args, plugins) {
    const { ctx, data } = chart;
    const centreX = chart.getDatasetMeta(0).data[0].x;
    const centreY = chart.getDatasetMeta(0).data[0].y;

    ctx.save();
    ctx.font = "bold 10px sans-serif";
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(data?.datasets[0]?.centerText, centreX, centreY);
  },
};

export function DoughnutChart({ data }) {
  return <Doughnut data={data} plugins={[doughnutLabel]} />;
}
